import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'core/services';
import { SplugConfigService } from 'core/splug';
import { StringUtils } from 'core/utils';
import { distinctUntilChanged, filter, fromEvent, interval, map, race, startWith, take } from 'rxjs';
import { JwtRefreshService } from './global-services/jwt-refresh.service';
import { JwtService } from './global-services/jwt.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  _title = 'designer';


  get darkModeMedia() {
    return window.matchMedia('(prefers-color-scheme: dark)')
  }

  readonly darkModeObs = fromEvent(this.darkModeMedia, 'change').pipe(
    startWith(this.darkModeMedia.matches),
    map(() => this.darkModeMedia.matches)
  )

  get title() {

    return StringUtils.capitalize(this._title)
  }
  readonly jwtSubject = this._jwtService.jwtSubject;

  readonly jwtNotPresentObs = race(
    this.jwtSubject.pipe(filter(Boolean)),
    interval(1 * 1000).pipe(take(1), map(() => 'TIMEOUT' as const))
  ).pipe(
    take(1),
    filter(resp => resp === 'TIMEOUT'),
  )

  get favicon() {
    return document.getElementById('favicon') as HTMLLinkElement
  }

  readonly refreshTokenExistsSubject = this._jwtRefreshService.refreshTokenExistsSubject;

  constructor(
    private readonly _jwtService: JwtService,
    private readonly _jwtRefreshService: JwtRefreshService,
    private readonly _splugConfigService: SplugConfigService,
    private readonly _translateService: TranslateService,
    private readonly _languageService: LanguageService,
  ) {

    this._jwtRefreshService.init();

    this._languageService.selectedLanguageSubject.subscribe((lang) => {
      this._translateService.setDefaultLang(lang)
    })

  }

  ngOnInit() {


    this._jwtService.jwtSubject.pipe(
      map(Boolean),
      distinctUntilChanged()
    ).subscribe((authenticated) => {
      this._splugConfigService.authenticatedSubject.next(authenticated);
    })

    this.darkModeObs.subscribe((darkMode) => {
      if (darkMode) {
        this.favicon.href = './assets/logo-small-dark.png'
        return;
      }

      this.favicon.href = './assets/logo-small.png'
    })
  }


}
